import { all, fork } from 'redux-saga/effects';
import { combineReducers } from 'redux';
import { PersistPartial } from 'redux-persist/es/persistReducer';

import * as auth from './ducks/auth.duck';
import * as users from './ducks/users.duck';
import * as profile from './ducks/profile.duck';
import * as companies from './ducks/companies.duck';

import * as categories from './ducks/categories.duck';
import * as products from './ducks/product.duck';
import * as productTypes from './ducks/productType.duck';
import * as orders from './ducks/orders.duck';
import * as agreement from './ducks/agreement.duck';
import * as yaLocations from './ducks/yaLocations.duck';
import * as stores from './ducks/store.duck';
import * as cart from './ducks/cart.duck';
import * as productsCatalog from './ducks/product-catalog.duck';
import * as yandexLocation from './ducks/yandexLocation.duck';

import { base } from '../../_base';

export type TAppActions =
  | auth.TActions
  | companies.TActions
  | users.TActions
  | profile.TActions
  | categories.TActions
  | products.TActions
  | productTypes.TActions
  | orders.TActions
  | agreement.TActions
  | yaLocations.TActions
  | stores.TActions
  | cart.TActions
  | productsCatalog.TActions
  | yandexLocation.TActions;
export interface IAppState {
  i18n: typeof base.i18n.reducer;
  builder: typeof base.builder.initialState;
  auth: auth.IInitialState & PersistPartial;
  companies: companies.IInitialState & PersistPartial;
  users: users.IInitialState & PersistPartial;
  profile: profile.IInitialState & PersistPartial;
  categories: categories.IInitialState & PersistPartial;
  products: products.IInitialState & PersistPartial;
  productTypes: productTypes.IInitialState & PersistPartial;
  orders: orders.IInitialState & PersistPartial;
  agreement: agreement.IInitialState;
  yaLocations: yaLocations.IInitialState;
  yandexLocation: yandexLocation.IInitialState;
  stores: stores.IInitialState & PersistPartial;
  cart: cart.IInitialState & PersistPartial;
  productsCatalog: productsCatalog.IInitialState & PersistPartial;
}

export const rootReducer: (state: IAppState, action: TAppActions) => IAppState =
  combineReducers<IAppState, TAppActions>({
    auth: auth.reducer,
    companies: companies.reducer,
    users: users.reducer,
    profile: profile.reducer,
    i18n: base.i18n.reducer,
    builder: base.builder.reducer,
    categories: categories.reducer,
    products: products.reducer,
    productTypes: productTypes.reducer,
    orders: orders.reducer,
    agreement: agreement.reducer,
    yaLocations: yaLocations.reducer,
    yandexLocation: yandexLocation.reducer,
    stores: stores.reducer,
    cart: cart.reducer,
    productsCatalog: productsCatalog.reducer,
  });

export function* rootSaga() {
  yield all(
    [
      auth.saga,
      companies.saga,
      users.saga,
      profile.saga,
      categories.saga,
      stores.saga,
      products.saga,
      productTypes.saga,
      orders.saga,
      agreement.saga,
      yaLocations.saga,
      yandexLocation.saga,
      cart.saga,
      productsCatalog.saga,
    ].map(saga => fork(saga))
  );
}
